import React, {useContext} from 'react';
import {AuthContext} from 'contexts';
import {blackListService} from 'services/blackListService';
import {FaRegTrashAlt} from 'react-icons/fa';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

const MySwal = withReactContent(Swal);

interface DeleteBlackListUserButtonProps {
    userId: string;
    userName: string;
    photoUrl?: string;
    onUserDeleted: (userId: string) => void;
}

export const DeleteBlackListUserButton: React.FC<DeleteBlackListUserButtonProps> = ({
    userId,
    userName,
    photoUrl,
    onUserDeleted
}) => {
    const {env} = useContext(AuthContext);

    const handleDelete = async () => {
        if (!env) {
            return;
        }

        const result = await MySwal.fire({
            html: photoUrl ? (
                <img
                    src={photoUrl}
                    alt={`Photo of ${userName}`}
                    style={{objectFit: 'scale-down'}}
                    className="w-100"
                    height={300}
                />
            ) : undefined,
            title: `Удалить пользователя "${userName}" из черного списка?`,
            confirmButtonText: 'Да',
            confirmButtonColor: '#D9292E',
            cancelButtonText: 'Нет',
            showCancelButton: true,
            showConfirmButton: true,
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await blackListService.delete(env, userId);
            onUserDeleted(userId);
            toast.success('Пользователь успешно удален из черного списка');
        } catch (error) {
            console.error('Error deleting user:', error);
            toast.error('Ошибка при удалении пользователя');
        }
    };

    return (
        <button
            className="btn btn-outline-danger btn-sm d-flex flex-row align-items-center"
            onClick={(e) => {
                e.stopPropagation();
                handleDelete();
            }}
            title="Удалить из черного списка"
        >
            <FaRegTrashAlt size={14} style={{marginRight: 4}}/>
            Удалить
        </button>
    );
};
